import React from 'react';
import '../../App.css';


function About() {
return (
    <div className="about">
        <br/><br/><br/><br/> <br/><br/>
        <img src="../c2.JPG" alt="inside" className="img"/>
        <h1> YES!  YES! YES! YES! YES! YES! YES! YES! YES! YES! YES! YES!</h1>
       
    </div>
    
)
}
export default About;